import React, {Component} from "react";
import BackToUpperLevel from "./BackToUpperLevel.js";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import {client, title} from "../constName.json"
import axios from "axios";
import {
  BASE_LINK,
  RSET_TOKEN_URL
  // WECHAT_TOKEN_URL,
} from "../actions/types";
import icon from './../images/logo.png';
import {Link} from "react-router-dom";
import logo_1 from "../images/logo_1.png";
import NavigateBefore from "@material-ui/icons/NavigateBefore";

class Login extends Component {
  state = {
    username: "",
    password: "",
    showPassword: false,
    open: false,
    errMessage: ""
  };
  handleChange = prop => event => {
    this.setState({[prop]: event.target.value});
  };
  handleClickShowPassword = () => {
    this.setState(state => ({showPassword: !this.state.showPassword}));
  };
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({open: false});
  };

  login() {
    const {username, password} = this.state;
    // axios.post(`${WECHAT_TOKEN_URL}`).then(res=>{
    //   localStorage.setItem("X-AUTH-TOKEN",res.data)
    // })
    axios
      .post(`${RSET_TOKEN_URL}?username=${username}&password=${password}`)
      .then(res => {
        localStorage.setItem("X-AUTH-TOKEN", res.data.token);
        this.props.history.push(BASE_LINK);
        // this.setState({open:})
      })
      .catch(err => {
        // console.log(err.response);return;
        this.setState({open: true, errMessage: err.response.data || "登录失败"});
      });
  }

  thirdLogin() {
    window.location.replace(`http://222.16.4.102:8484/lab/cas/login`);
  }

  componentDidMount() {
    console.log(this.props);
  }

  render() {
    let showTips = false;
    if (this.props.location.state) {
      showTips = true;
    }
    return (
      <React.Fragment>
        {/*<BackToUpperLevel history={this.props.history.go(-1)}/>*/}
        <div className="loginIndex">
          <div style={{height: 44}}>
            <div className="back-contain">
              <NavigateBefore className="back-arrow" onClick={() => this.props.history.go(-1)}/>
            </div>
          </div>
          <div className="login-header">
            <div className="login-brand">
              {/*<img src={icon}/>*/}
              <img src={logo_1}/>
              <div>
                <div className="navbar-header-en" style={{float: "inherit"}}>{client}</div>
                <div className="navbar-header-cn">{title}</div>
                {showTips && <div className="login-header-div2" style={{fontSize: 12}}>(请先进行登录)</div>}
              </div>
            </div>
          </div>
        </div>
        <div className="container login-div">
          <TextField
            id="username"
            label="登录名"
            fullWidth
            value={this.state.username}
            onChange={this.handleChange("username")}
            margin="normal"
            variant="outlined"
            style={{marginBottom: 16}}/>
          <TextField color="secondary"
                     id="password"
                     type={this.state.showPassword ? "text" : "password"}
                     label="密码"
                     fullWidth
                     value={this.state.password}
                     onChange={this.handleChange("password")}
                     InputProps={{
                       endAdornment: (
                         <InputAdornment position="end">
                           <IconButton aria-label="Toggle password visibility"
                                       onClick={this.handleClickShowPassword}>
                             {this.state.showPassword ? <VisibilityOff/> : <Visibility/>}
                           </IconButton>
                         </InputAdornment>
                       )
                     }}
                     variant="outlined"
                     style={{marginBottom: 16}}/>
          <Button
            class={"MuiButtonBase-root-75 MuiButton-root-78 MuiButton-text-80 MuiButton-flat-83 index-main-botton "}
            style={{
              width: "100%",
              marginTop: 16,
              color: "#fff",
              lineHeigth: "20px"
            }} onClick={() => {
            this.login();
          }}>
            登录
          </Button>
          <Button
            class={"MuiButtonBase-root-75 MuiButton-root-78 MuiButton-text-80 MuiButton-flat-83 index-main-botton "}
            style={{
              width: "100%",
              marginTop: 16,
              color: "#fff",
              lineHeigth: "20px",
              display: "none"
            }} onClick={() => {
            this.thirdLogin();
          }}>
            中央认证登录
          </Button>
          <Button hidden={true} style={{
            width: "100%", marginTop: 16, display: "none"
          }}>
          <span className={"ForgetPassword"} onClick={() => {
            console.log('忘记密码?')
          }}>忘记密码？</span>
          </Button>
        </div>
        {this.renderSnackBar()}
      </React.Fragment>
    );
  }

  renderSnackBar() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        message={<span>{this.state.errMessage}</span>}
        action={[
          <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleClose}>
            <CloseIcon/>
          </IconButton>
        ]}
      />
    );
  }
}

export default Login;
